import ButtonIcon from "@visa/vds/button-icon";
import Icon from "@visa/vds/icon";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import React from "react";

import "./SearchFieldTooltip.css";

const SearchFieldTooltip = (props) => {
  return (
    <>
      <span className="label-with-tooltip">{props.label}</span>
      <Tooltip
        placement="right"
        overlay={<span>{props.text ? props.text : ""}</span>}
      >
        <ButtonIcon
          ariaLabel="store-open"
          className="btn-searchField-tooltip"
          iconType="light-tiny"
        >
          <Icon name="info" resolution="tiny" />
        </ButtonIcon>
      </Tooltip>
    </>
  );
};
export default SearchFieldTooltip;
